var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"logo"},[_c('router-link',{staticStyle:{"cursor":"pointer"},attrs:{"to":_vm.getHomeLink(),"tag":"span"}},[_c('v-img',{attrs:{"contain":"","src":require("@/assets/logo.png")}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }